import sdl from '@jds/react-generated-sdl/JDSNotificationButton';
import type { JDSNotificationButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSNotificationButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    isDisabled = false,
    kind = 'secondary',
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { isDisabled, kind, ariaLabel, ...rest },
    'JDSNotificationButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const NotificationButton = withLogic(
  Component
) as React.FC<JDSNotificationButtonProps> & { slotName?: string };

NotificationButton.displayName = 'NotificationButton';
NotificationButton.slotName = 'jds_notification_button';

export { NotificationButton, type JDSNotificationButtonProps };
